const SEPERATOR = '|';

export const getErrorCodeWithVariables = (error: string) => {
  const [errorCode, ...variables] = error.split(SEPERATOR);
  const variableDict = variables.reduce(
    (dict, current, index) => ({ ...dict, [index]: current }),
    {} as { [k: number]: string }
  );

  return { errorCode, variables: variableDict };
};
